import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as classNames from 'classnames';
import UrlHelpers from '../shared/url_helpers';
import AboutDirectCheckoutBullets from './about_direct_checkout_bullets';
import { CURRENCY_CODES, COUNTRY_CODES } from '../shared/constants';

const US_RP_LABEL_IMAGE_CLASS = 'payment-setup__provider-logo--rp-us';
const CA_RP_LABEL_IMAGE_CLASS = 'payment-setup__provider-logo--rp-ca';
const EU_RP_LABEL_IMAGE_CLASS = 'payment-setup__provider-logo--rp-eu';
const EUR_EU_RP_LABEL_IMAGE_CLASS = 'payment-setup__provider-logo--rp-eu-eur';

function DirectCheckoutWrapper(props) {
  function labelImageClass() {
    if (props.paymentSelection === 'EU_DC_OR_PAYPAL' || props.paymentSelection === 'PAYPAL_WITH_EU_DC_UPGRADE' || props.paymentSelection === 'UPDATE_EU_DC') {
      if (props.shopCurrency === CURRENCY_CODES.EUR) {
        return EUR_EU_RP_LABEL_IMAGE_CLASS;
      }

      return EU_RP_LABEL_IMAGE_CLASS;
    }

    if (props.shopCurrency === CURRENCY_CODES.USD && props.bankCountryCode === COUNTRY_CODES.US) {
      return US_RP_LABEL_IMAGE_CLASS;
    }

    return CA_RP_LABEL_IMAGE_CLASS;
  }

  return (
    <div className="payment-setup">
      <div className={classNames('payment-setup__label payment-setup__label--dc scaling-mt-2', props.className)}>
        {props.children}
        <label htmlFor="shop-settings-dc-radio">
          <div className={classNames('payment-setup__provider-logo', labelImageClass())} />
        </label>
      </div>
      <div className="payment-setup__info">
        <AboutDirectCheckoutBullets
          directCheckoutFeePercent={props.directCheckoutFeePercent}
          directCheckoutIntlFeePercent={props.directCheckoutIntlFeePercent}
          shopCurrency={props.shopCurrency}
        />
      </div>
    </div>
  );
}

DirectCheckoutWrapper.defaultProps = {
  children: null,
  className: '',
};

DirectCheckoutWrapper.propTypes = {
  directCheckoutFeePercent: PropTypes.number.isRequired,
  directCheckoutIntlFeePercent: PropTypes.number.isRequired,
  shopCurrency: PropTypes.string.isRequired,
  bankCountryCode: PropTypes.string.isRequired,
  children: PropTypes.element,
  className: PropTypes.string,
  paymentSelection: PropTypes.string.isRequired,
};

export default DirectCheckoutWrapper;



// WEBPACK FOOTER //
// ./javascripts/components/shop/direct_checkout_wrapper.jsx